module.exports = {"TXTCLI_Current_Balance":{"id":"TXTCLI_Current_Balance","defaultMessage":"Nuværende saldo","flags":["TRACK"],"track":"Current Balance"}}